import React from "react";
import { JsonViewer } from "../../../../../common/components/json-viewer";

export const TransactionLogDetails = ({
  log,
  onBack,
  onViewFlow,   // 🔥 NOW INCLUDED
}: any) => {
  if (!log) return null;

  const ctx = log.logData?.context || {};

  const transactionId =
    log.transaction_id || ctx.transaction_id || "";

  return (
    <div className="p-4 bg-white border shadow-md rounded-md mt-4">

      {/* Back Button */}
      <div className="flex justify-between mb-4">
        <button
          onClick={onBack}
          className="px-4 py-2 bg-gray-600 text-white rounded"
        >
          ← Back
        </button>

        {/* View Flow Button */}
        {/* {transactionId && (
          <button
            onClick={() => onViewFlow(transactionId)}
            className="px-4 py-2 bg-blue-600 text-white rounded"
          >
            View Flow →
          </button>
        )} */}
      </div>

      <h2 className="text-xl font-bold mb-4">Transaction Log Details</h2>

      {/* Summary */}
      <div className="grid grid-cols-2 gap-4 mb-4 text-sm">
        <div><strong>Action:</strong> {log.action}</div>
        <div><strong>Request Type:</strong> {log.requestType}</div>

        <div><strong>Transaction ID:</strong> {transactionId || "-"}</div>
        <div><strong>Message ID:</strong> {log.message_id || ctx.message_id || "-"}</div>

        <div><strong>BAP ID:</strong> {log.bap_id || ctx.bap_id || "-"}</div>
        <div><strong>Timestamp:</strong> 
          {new Date(log.timestamp).toLocaleString()}
        </div>
      </div>

      {/* Collapsible Raw JSON Viewer */}
      <JsonViewer data={log} label="Raw Log JSON" />
    </div>
  );
};
